import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/components/ContactInquiryPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/products/[slug]/client/ProductDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/products/[slug]/client/ProductDetailView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Products/FaqEnquiryGrid.tsx");
